import { config } from "../../config";
import { createApiAxios } from "./createApiAxios";

export const assetDetailsGw = createApiAxios(
  config.SID_ASSET_DETAILS_GW_BASE_URL || "",
  "/v1",
);
